import styled from "styled-components";

export const Container = styled.footer`
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  background: #000;
  font: 400 1rem "Roboto", sans-serif;
`;

export const Icons = styled.div`
  a {
    text-decoration: none;
    color: #fff;
    padding-right: 15px;

    &:hover {
      transition: 0.8s all;
      color: #4cd964;
    }
  }
`;

export const Presentation = styled.div`
  color: #fff;
  a {
    padding-left: 5px;
    text-decoration: none;
    color: #fff;
  }
`;
